import { httpAuth } from './http'

const login = async ({ login, password }) => await httpAuth.post('/api/okno/auth/login', { username: login, password })

const check = async () => await httpAuth.post('/api/okno/auth/check')

const logout = async () => await httpAuth.get('/api/okno/auth/logout')

export const AuthService = {
	login,
	check,
	logout
}
